import type { Building } from "building-types/building/buildingTypes";
import { DoorOperationType } from "building-types/doors/doorOperationTypes";
import type { Room } from "building-types/rooms/roomTypes";
import { WallType } from "building-types/walls/wallEnums";
import { wallIndexForLevel } from "doc/buildingHandleUtils";

/**
 * By default the garage count is derived from the operation type of the doors
 * within the building. However, this value can be manually overridden
 * by the room attributes
 */

export default function getGarageCount(building: Pick<Building, "rooms" | "walls">): number {
  let garageCount = 0;

  for (const id in building.rooms) {
    const room = building.rooms[id];
    garageCount += getRoomGarageCount(building, room);
  }

  return garageCount;
}

export function getRoomGarageCount(building: Pick<Building, "walls">, room: Room): number {
  if (!room || !building.walls[room.level.id]) {
    return 0;
  }

  const wallIndex = wallIndexForLevel(building, room.level.id);
  const walls = wallIndex.wallsInRoom(room);
  const roomAttrbutesCount = room.attributes?.garageCount;

  let garageCount = 0;

  if (roomAttrbutesCount !== undefined) {
    return roomAttrbutesCount;
  }

  for (const wall of walls) {
    if (wall.wallType !== WallType.SOLID) {
      continue;
    }

    for (const door of wall.doorPlacements) {
      if (door.descriptor.operationType === DoorOperationType.GARAGE_SINGLE) {
        garageCount += 1;
      }

      if (door.descriptor.operationType === DoorOperationType.GARAGE_DOUBLE) {
        garageCount += 2;
      }
    }
  }

  return garageCount;
}
